import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SelectBox from './SelectBox'
import { instituteOnboardingList } from '../../redux/slices/company'

export default function InstituteFilterBox({ value, onChange }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const institutes = useSelector(state => state?.instituteOnboardingList?.data)

    useEffect(() => {
        dispatch(instituteOnboardingList({ pageable: { pageSize: 1000, currentPage: 0, search: '' }, navigate, silent: true }))
    }, [dispatch, navigate])

    const options = (institutes || []).map(val => {
        const institute = val?.instituteBranches?.[0]?.institute || val
        return {
            value: institute?.id,
            label: institute?.institute_name || val?.institute_name || (institute?.id ? `Institute ${institute.id}` : ''),
        }
    }).filter(opt => opt.value)

    return (
        <SelectBox
            label_name={t('common.institute', 'Institute')}
            mandatory={false}
            option={options}
            name="instituteId"
            value={value || undefined}
            onChange={(selected) => onChange(selected || '')}
            onClear={() => onChange('')}
        />
    )
}
